import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
} from '@mui/material';
import {
  Construction as ConstructionIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';

interface ComingSoonProps {
  open: boolean;
  onClose: () => void;
  feature?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ open, onClose, feature = "This feature" }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
          <ConstructionIcon color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h5" component="span" fontWeight="bold">
            Coming Soon
          </Typography>
        </Box>
        <Chip 
          label="Under Development" 
          color="primary" 
          variant="outlined"
          icon={<ScheduleIcon />}
          size="small"
        />
      </DialogTitle>
      
      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        <Typography variant="h6" gutterBottom color="text.primary">
          {feature} is currently under development
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Our team is working hard to bring you this exciting feature. 
          Stay tuned for updates!
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Expected release: Q2 2025
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button 
          onClick={onClose} 
          variant="contained" 
          size="large"
          sx={{ px: 4 }}
        >
          Got it!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComingSoon;
